var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:( _obj = {}, _obj[_vm.priority] = _vm.priority, _obj[_vm.shape] = _vm.shape, _obj['full-width'] =  _vm.fullWidth, _obj ),attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }